import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Todas as telas do Kanban são LAZY (carregadas sob demanda por rota) — assim as
// ~20 telas grandes (board, flows, email/GrapesJS, projetos, chat) NÃO entram no
// bundle inicial do dashboard. Quem só usa a caixa de entrada não baixa nada disso.
const perms = ['administrator', 'agent', 'custom_role'];

// Portão de rota POR MÓDULO (fecha a brecha de URL direta): função personalizada só
// entra se tiver o `<mod>_module`; admin/agente base passam sempre. Antes as rotas
// usavam ['administrator','agent','custom_role'] — o 'custom_role' deixava QUALQUER
// função personalizada abrir a tela pela URL mesmo com o item escondido do menu.
// Mesmo padrão de 3 camadas do Synapse (menu + rota + backend 403).
const mod = p => ({ permissions: ['administrator', 'agent', p] });

// Telas de RELATÓRIO: além do módulo, seguem o feature flag REPORTS da conta (se
// "Reports" está desligado, nenhum relatório aparece — igual aos nativos).
const modReport = p => ({
  permissions: ['administrator', 'agent', p],
  featureFlag: FEATURE_FLAGS.REPORTS,
});

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_home',
    meta: mod('kanban_module'),
    component: () => import('./KanbanBoard.vue'),
  },
  {
    // [AstraChat] Módulo de Crédito/Consignado (gestão completa).
    path: frontendURL('accounts/:accountId/credit'),
    name: 'kanban_credit',
    meta: mod('credit_module'),
    component: () => import('./KanbanCredit.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/credit/reports'),
    name: 'kanban_credit_reports',
    meta: mod('credit_module'),
    component: () => import('./KanbanCreditReports.vue'),
  },
  {
    // [AstraChat] Funil ao vivo do Crédito (sessões em andamento, polling 30s).
    path: frontendURL('accounts/:accountId/credit/funnel'),
    name: 'kanban_credit_funnel',
    meta: mod('credit_module'),
    component: () => import('./KanbanCreditFunnel.vue'),
  },
  {
    // [AstraChat] Prospecção Ativa do Crédito (listagem de campanhas).
    path: frontendURL('accounts/:accountId/credit/prospecting'),
    name: 'kanban_credit_prospecting',
    meta: mod('credit_module'),
    component: () => import('./KanbanCreditProspecting.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/credit/prospecting/new'),
    name: 'kanban_credit_prospecting_new',
    meta: mod('credit_module'),
    component: () => import('./KanbanCreditProspectingNew.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/credit/prospecting/:campaignId'),
    name: 'kanban_credit_prospecting_detail',
    meta: mod('credit_module'),
    component: () => import('./KanbanCreditProspectingDetail.vue'),
  },
  {
    // Dashboard App aberto em tela cheia (opção "Exibir no menu principal").
    path: frontendURL('accounts/:accountId/apps/:appId'),
    name: 'dashboard_app_show',
    meta: { permissions: perms },
    component: () => import('./DashboardAppEmbed.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/funnels'),
    name: 'kanban_funnels',
    meta: mod('kanban_module'),
    component: () => import('./KanbanFunnels.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/kanban/cards/:cardId'),
    name: 'kanban_card_detail',
    meta: mod('kanban_module'),
    component: () => import('./KanbanCardDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'kanban_flows',
    meta: mod('flows_module'),
    component: () => import('./KanbanFlows.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/crm-reports'),
    name: 'kanban_reports',
    meta: modReport('crm_reports_module'),
    component: () => import('./KanbanReports.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/calls-report'),
    name: 'kanban_calls',
    meta: modReport('calls_module'),
    component: () => import('./KanbanCalls.vue'),
  },
  {
    // legado: o painel de Ligações nativo do Chatwoot assumiu o /calls. Mantido
    // em /calls-legacy só para links antigos; fora do menu.
    path: frontendURL('accounts/:accountId/calls-legacy'),
    name: 'kanban_calls_center',
    meta: modReport('calls_module'),
    component: () => import('./KanbanCallsCenter.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history/:executionId'),
    name: 'kanban_flow_execution_detail',
    meta: mod('flows_module'),
    component: () => import('./KanbanFlowExecutionDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history'),
    name: 'kanban_flow_history',
    meta: mod('flows_module'),
    component: () => import('./KanbanFlowHistory.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'kanban_flow_builder',
    meta: mod('flows_module'),
    component: () => import('./KanbanFlowBuilder.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects'),
    name: 'kanban_projects',
    meta: mod('projects_module'),
    component: () => import('./KanbanProjects.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/projects/:projectId'),
    name: 'kanban_project_detail',
    meta: mod('projects_module'),
    component: () => import('./KanbanProjectDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/appointments'),
    name: 'kanban_appointments',
    meta: mod('appointments_module'),
    component: () => import('./KanbanAppointments.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador'),
    name: 'kanban_campaigns',
    meta: mod('disparador_module'),
    component: () => import('./KanbanCampaigns.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/new'),
    name: 'kanban_campaign_wizard',
    meta: mod('disparador_module'),
    component: () => import('./KanbanCampaignWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/disparador/:campaignId'),
    name: 'kanban_campaign_detail',
    meta: mod('disparador_module'),
    component: () => import('./KanbanCampaignDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email'),
    name: 'kanban_email',
    meta: mod('email_module'),
    component: () => import('./KanbanEmail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/new'),
    name: 'kanban_email_wizard',
    meta: mod('email_module'),
    component: () => import('./KanbanEmailWizard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/new'),
    name: 'kanban_email_template_new',
    meta: mod('email_module'),
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/:templateId'),
    name: 'kanban_email_template',
    meta: mod('email_module'),
    component: () => import('./KanbanEmailTemplateEditor.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/email/:campaignId'),
    name: 'kanban_email_report',
    meta: mod('email_module'),
    component: () => import('./KanbanEmailReport.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/internal-chats'),
    name: 'kanban_internal_chats',
    meta: mod('internal_chat_module'),
    component: () => import('./KanbanChats.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/connections'),
    name: 'kanban_connections',
    // gestão de conexões é de administrador (o backend recusa o resto de todo
    // jeito; aqui é só para não abrir uma tela que vai falhar)
    meta: { permissions: ['administrator'] },
    component: () => import('./KanbanConnections.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/synapse'),
    name: 'synapse',
    // função personalizada só entra com o módulo Synapse concedido (sem isto a
    // tela abriria pela URL mesmo com o item escondido do menu)
    meta: { permissions: ['administrator', 'agent', 'synapse_module'] },
    component: () => import('../synapse/SynapseView.vue'),
  },
  {
    // ambientes do Synapse (o que cada função vê/faz + prompt do Cérebro):
    // configurar quem pode o quê é decisão de administrador
    path: frontendURL('accounts/:accountId/synapse/settings'),
    name: 'synapse_settings',
    meta: { permissions: ['administrator'] },
    component: () => import('../synapse/SynapseSettings.vue'),
  },
  {
    // Rotinas do Jarvis (alarmes/lembretes agendados por voz) — página de gestão
    path: frontendURL('accounts/:accountId/synapse/routines'),
    name: 'synapse_routines',
    meta: { permissions: ['administrator', 'agent', 'synapse_module'] },
    component: () => import('../synapse/SynapseRoutines.vue'),
  },
];
